<template>
  <MultiSelect
    v-model="model"
    :options="options"
    placeholder="Add to collection"
  />
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import MultiSelect from "./MultiSelect.vue";

const props = defineProps<{
  modelValue: string[];
  userId: string;
  playlistListUrl?: string;
}>();
const emit = defineEmits<{ "update:modelValue": [string[]] }>();

const model = computed({
  get: () => props.modelValue,
  set: (v: string[]) => emit("update:modelValue", v),
});

const options = ref<{ label: string; value: string }[]>([]);

onMounted(async () => {
  try {
    const playlists: { _id: string; name: string }[] = await fetch(
      props.playlistListUrl || "/api/playlist/list",
      { credentials: "include" }
    ).then((r) => r.json());
    options.value = playlists.map((p) => ({
      value: p._id.toString(),
      label: p.name,
    }));
  } catch (err) {
    console.error("Failed to load playlist list", err);
  }
});
</script>
